import * as yup from 'yup'

const SchemaValidations = yup.object().shape({
  receiverEmail: yup.string().email('No es un correo válido')
  // phone: yup.string().matches(/^[0-9]+$/, 'Invalid phone number'),
})

export default SchemaValidations